import React, {useEffect, useState} from 'react'
import {Radio, Checkbox} from 'antd'
import '../css/progress.sass'
import {WeChatOrganizationTypeDict} from "../../../config/MerchantType";
import {useDispatch, useSelector} from "react-redux";
import {setSubMerchantMaterialInfo, subMerchantMaterialInfoSelector} from "../../../store/merchant";
import StepController from "./stepController";
import {TO_COMPANY_ACCOUNT, TO_PERSONAL_ACCOUNT} from "../../../config/bankAccountType";

const OrganizationCard = (props) => {
    let organization = props.organization;
    let height = {height: '226px'};
    return (
        <li style={height} key={organization.id}>
            <label htmlFor={organization.id}>
                <div className='flex spabet marb20'>
                    <p className='title'>{organization.title}</p>
                    <Radio id={organization.id} value={organization.organizationType}/>
                </div>
                <div className='marb10'>定义：{organization.organizationDescription}</div>
                <div className='marb10'>
                    所需资料：{organization.organizationLicense}
                </div>
                <div>交易限额：<a className="refuse">{organization.limitAmount}</a></div>
            </label>
        </li>
    );
}

const Organizations = [{
    id: 'micro_sub_merchant',
    title: WeChatOrganizationTypeDict.ORGANIZATION_TYPES[WeChatOrganizationTypeDict.MICRO_SUB_MERCHANT],
    organizationType: WeChatOrganizationTypeDict.MICRO_SUB_MERCHANT,
    organizationDescription: '无营业执照的个人商家',
    organizationLicense: '无限经营材料',
    hasAmountLimit: true,
    limitAmount: WeChatOrganizationTypeDict.SUB_MCH_AMOUNT_LIMIT_DESC[WeChatOrganizationTypeDict.MICRO_SUB_MERCHANT],
}, {
    id: 'self_employment_merchant',
    title: WeChatOrganizationTypeDict.ORGANIZATION_TYPES[WeChatOrganizationTypeDict.SELF_EMPLOYMENT_MERCHANT],
    organizationType: WeChatOrganizationTypeDict.SELF_EMPLOYMENT_MERCHANT,
    organizationDescription: '个体户、个体工商户、个体经营',
    organizationLicense: '营业执照、经营者证件',
    hasAmountLimit: true,
    limitAmount: WeChatOrganizationTypeDict.SUB_MCH_AMOUNT_LIMIT_DESC[WeChatOrganizationTypeDict.SELF_EMPLOYMENT_MERCHANT],
}, {
    id: 'enterprise_business',
    title: WeChatOrganizationTypeDict.ORGANIZATION_TYPES[WeChatOrganizationTypeDict.ENTERPRISE_BUSINESS],
    organizationType: WeChatOrganizationTypeDict.ENTERPRISE_BUSINESS,
    organizationDescription: '有限公司、有限责任公司',
    organizationLicense: '营业执照、经营者证件',
    hasAmountLimit: false,
    limitAmount: WeChatOrganizationTypeDict.SUB_MCH_AMOUNT_LIMIT_DESC[WeChatOrganizationTypeDict.ENTERPRISE_BUSINESS],
}];

const SelectOrganizationType = () => {
    const subMerchantMaterialInfo = useSelector(subMerchantMaterialInfoSelector);
    const [readContract, setReadContract] = useState(subMerchantMaterialInfo.readContract);
    const dispatch = useDispatch();
    const changeOrganizationType = (e) => {
        let material = {
            organizationType: e.target.value,
        };
        switch(e.target.value) {
            case WeChatOrganizationTypeDict.ENTERPRISE_BUSINESS:
                material.bindBankAccountType = TO_COMPANY_ACCOUNT;
                break;
            case WeChatOrganizationTypeDict.SELF_EMPLOYMENT_MERCHANT:
                break;
            case WeChatOrganizationTypeDict.MICRO_SUB_MERCHANT:
                material.bindBankAccountType = TO_PERSONAL_ACCOUNT;
                break;
        }
        dispatch(setSubMerchantMaterialInfo({organizationType: e.target.value}));
    };
    let checkBoxStyle = !readContract ? {
        border: '1px solid red',
    } : {};
    const nextStepAction = () => {
        if (!readContract) {
            return false;
        }
        dispatch(setSubMerchantMaterialInfo({readContract}));
        return true;
    };
    return (
        <>
            <div className='mainStay'>
                <Radio.Group onChange={changeOrganizationType} value={subMerchantMaterialInfo.organizationType}>
                    <ul className='flex'>
                        {Organizations.map((organization, index) => {
                            return (<OrganizationCard organization={organization} key={index}/>)
                        })}
                    </ul>
                </Radio.Group>
                <div className='treaty'>
                    <Checkbox style={checkBoxStyle} defaultChecked={readContract} onChange={(e) => {
                        setReadContract(!readContract);
                    }} autoFocus={!readContract}>已阅读并同意</Checkbox>
                    <span className='treatyCtx' onClick={() => {
                        window.open('https://pay.weixin.qq.com/index.php/public/apply_sign/protocol_v2')
                    }}>《磁力圈支付服务协议》</span>
                </div>
            </div>
            <StepController preStepButtonName={'上一步'} nexStepButtonName={'下一步'} nextStepAction={nextStepAction}/>
        </>
    );
}
export default SelectOrganizationType;